/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LessonStatusInput = {
    status: LessonStatusInput.status;
};
export namespace LessonStatusInput {
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
    }
}

